import { render } from "./ui-header.vue?vue&type=template&id=e5cf69b6&scoped=true"
import script from "./ui-header.vue?vue&type=script&lang=js"
export * from "./ui-header.vue?vue&type=script&lang=js"

import "./ui-header.vue?vue&type=style&index=0&id=e5cf69b6&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5cf69b6"]])

export default __exports__